import styles from "./QuestionChips.module.css";

interface QuestionChipsProps {
	options: string[];
	value: string[];
	onChange: (value: string[]) => void;
	noneOptionKey: string;
	additionalTextValue: string;
	onAdditionalTextChange: (value: string) => void;
	additionalTextPlaceholder: string;
	specifyLabel?: string;
	t: (key: string) => string;
}

export function QuestionChips({
	options,
	value,
	onChange,
	noneOptionKey,
	additionalTextValue,
	onAdditionalTextChange,
	additionalTextPlaceholder,
	specifyLabel,
	t,
}: QuestionChipsProps) {
	function handleChipClick(option: string) {
		if (option === noneOptionKey) {
			onChange([noneOptionKey]);
			return;
		}

		const withoutNone = value.filter((v) => v !== noneOptionKey);
		const isSelected = withoutNone.includes(option);

		if (isSelected) {
			onChange(withoutNone.filter((v) => v !== option));
		} else {
			onChange([...withoutNone, option]);
		}
	}

	return (
		<div>
			<div className={styles.chipsContainer}>
				{options.map((option) => {
					const isSelected = value.includes(option);
					return (
						<button
							key={option}
							type="button"
							className={
								isSelected ? styles.chipSelected : styles.chipUnselected
							}
							onClick={() => handleChipClick(option)}
						>
							{t(option)}
						</button>
					);
				})}
			</div>
			{specifyLabel && (
				<span className={styles.specifyLabel}>{specifyLabel}</span>
			)}
			<textarea
				className={styles.additionalTextarea}
				value={additionalTextValue}
				onChange={(e) => onAdditionalTextChange(e.target.value)}
				placeholder={additionalTextPlaceholder}
				aria-label={specifyLabel}
			/>
		</div>
	);
}
